import script from "./floatingBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./floatingBtn.vue?vue&type=script&setup=true&lang=js"

import "./floatingBtn.vue?vue&type=style&index=0&id=4190144b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4190144b"]])

export default __exports__